import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { TimelineMax } from "gsap";
import { SanGameConfig } from "../../../SanGameConfig";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { BLEND_MODES } from "pixi.js";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { WinCounter } from "../countup/WinCounter";

export class WinAnimation extends BaseView {

    private seq_Win_Fog:Sequence;
    private seq_Win_Spark:Sequence;

    private tl:TimelineMax;


    constructor (){
        super();
        StageManager.getLayer(SanGameConfig.instance.LAYERS.FX_WIN.name).addChild(this);
    }

    protected initAnimations():void{
        this.seq_Win_Fog = this.addChild(this.createSeq(GameResources.getTextures("Win_Xplod_A")));
        this.seq_Win_Spark = this.addChild(this.createSeq(GameResources.getTextures("Win_Xplod_B")));

        this._hasInit = true;
        this.onResize();
    }

    private createSeq(texture?:PIXI.Texture[]):Sequence{
        const seq:Sequence =  Sequence.createSequence(texture);
        seq.blendMode = BLEND_MODES.ADD;
        seq.scale.set(3,3);
        return seq;
    }

    public winLvlManiacAnimation(lvl:number = 0):TimelineMax{

        if(!this._hasInit) this.initAnimations();

        this.tl = Helper.timeLineKiller(this.tl, new TimelineMax());
        this.seq_Win_Fog.position.y = 250;
        this.seq_Win_Fog.position.y = 250;

        this.seq_Win_Fog.scale.set(Math.min(lvl+1,2))
        this.tl.add(this.seq_Win_Fog.playAnimation({
            onStart:() => this.seq_Win_Fog.alpha = 1,
            onCompleteCallback:() => 
            this.seq_Win_Fog.alpha = 0,
        }),0);  
        this.seq_Win_Spark.scale.set(Math.min(lvl,3))
        this.tl.add(this.seq_Win_Spark.playAnimation({
            onStart:() => this.seq_Win_Spark.alpha = 1,
            onCompleteCallback:() => this.seq_Win_Spark.alpha = 0,
        }),0);

        return this.tl;
    }

    public winLvlAnimation(lvl:number = 0):TimelineMax{

        if(!this._hasInit) this.initAnimations();

        this.tl = Helper.timeLineKiller(this.tl, new TimelineMax());

        this.seq_Win_Fog.position.y = 0;
        this.seq_Win_Fog.position.y = 0;

        if(lvl >= 1){
            this.seq_Win_Fog.scale.set(Math.min(lvl+1,2))
            this.tl.add(this.seq_Win_Fog.playAnimation({
                onStart:() => this.seq_Win_Fog.alpha = 1,
                onCompleteCallback:() => 
                this.seq_Win_Fog.alpha = 0,
            }),0);  
        }
        if(lvl >= 2){
            this.seq_Win_Spark.scale.set(Math.min(lvl,3))
            this.tl.add(this.seq_Win_Spark.playAnimation({
                onStart:() => this.seq_Win_Spark.alpha = 1,
                onCompleteCallback:() => this.seq_Win_Spark.alpha = 0,
            }),0);
        } 

        return this.tl;
    }

    public onResize():void{
        this.position = WinCounter.normalCounter.dim.position;
        this.position.y -= 30;
        this.position.x += 30;
    }
}